import { Link, useParams } from "react-router";
import { useDocs } from "../app/docs-context";
import { useAsync } from "../shared/lib/use-async";
import { EmptyState, ErrorState, LoadingState } from "../shared/ui/states";

export function CategoryPage() {
  const { slug = "" } = useParams();
  const { api, paths } = useDocs();
  const { data, error, loading, reload } = useAsync(
    (signal) => api.category(slug, signal),
    [api, slug],
  );

  if (loading) return <LoadingState />;
  if (error || !data)
    return (
      <ErrorState
        title="Category not found"
        description="This part of the documentation may have moved."
        onRetry={reload}
      />
    );

  return (
    <div className="mx-auto max-w-[900px] px-10 pb-20 pt-10">
      <nav
        className="mb-6 flex items-center gap-2 text-[0.82rem]"
        style={{ color: "var(--muted-foreground)" }}
        aria-label="Breadcrumb"
      >
        <Link to={paths.home} className="no-underline" style={{ color: "inherit" }}>
          Docs
        </Link>
        <span aria-hidden>/</span>
        <span style={{ color: "var(--foreground)" }}>{data.name}</span>
      </nav>

      <h1 className="mb-2 text-2xl font-bold tracking-tight" style={{ color: "var(--foreground)" }}>
        {data.name}
      </h1>
      {data.description && (
        <p className="mb-8 text-lg" style={{ color: "var(--muted-foreground)" }}>
          {data.description}
        </p>
      )}

      {data.articles.length === 0 ? (
        <EmptyState
          title="No articles here yet"
          description="Articles published in this category will be listed here."
        />
      ) : (
        <div className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(260px,1fr))]">
          {data.articles.map((article) => (
            <Link
              key={article.id}
              to={paths.article(article.slug)}
              className="rounded-lg border border-border bg-card p-5 no-underline transition-colors hover:border-primary/45"
            >
              <span
                className="mb-1 block text-[0.95rem] font-semibold"
                style={{ color: "var(--foreground)" }}
              >
                {article.title}
              </span>
              <span
                className="block text-sm leading-relaxed"
                style={{ color: "var(--muted-foreground)" }}
              >
                {article.summary}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
